import React, { useState, useEffect } from 'react';

import { Box } from '@mui/system';
import { FormikProps } from 'formik';

import { getProfileUtils, ISoftware } from '@pharmaplan/common';

import { useAppSelector } from '../../../hooks/useAppSelector';

import CustomSlider from '../CustomSlider';
import classes from './style';

interface ICustomRadioTable {
  formik: FormikProps<Record<string, number | string>>;
  isSignup?: boolean;
  softwareOptions?: Array<Pick<ISoftware, 'name' | 'softwareId'>>;
}

const defaultProps = {
  isSignup: false,
};

const marks = [
  {
    value: 1,
    label: '0%',
  },
  {
    value: 2,
    label: '25%',
  },
  {
    value: 3,
    label: '50%',
  },
  {
    value: 4,
    label: '75%',
  },
  {
    value: 5,
    label: '100%',
  },
];

const CustomRadioTable = ({
  formik,
  isSignup,
  softwareOptions,
}: ICustomRadioTable) => {
  const { values, setValues } = formik ?? {};
  const profileUtil = useAppSelector(getProfileUtils);
  const [rowItems, setRowItems] = useState(
    softwareOptions ?? profileUtil.softwares,
  );

  useEffect(() => {
    setRowItems(softwareOptions ?? profileUtil.softwares);
  }, [profileUtil, softwareOptions]);

  return (
    <Box
      component="div"
      sx={classes.customRadioButtonContainer}
      data-testid="test"
    >
      <CustomSlider label="" sx={classes.headerClass} marks={marks} value={0} />
      {rowItems?.map((rowItem) => {
        const { softwareId, name } = rowItem ?? {};
        const value = values[softwareId] ?? 1;
        const isValidID = value !== undefined || isSignup;

        return (
          isValidID && (
            <CustomSlider
              key={name}
              onChange={(event) =>
                setValues({
                  ...values,
                  [softwareId]: (event?.target as HTMLButtonElement)?.value,
                })}
              label={name}
              value={value}
            />
          )
        );
      })}
    </Box>
  );
};

CustomRadioTable.defaultProps = defaultProps;

export default CustomRadioTable;
